<template>
  <div>
<h2 class="goth">Sehr, viel, viele</h2>
<div class="grammatikparagrafbredd leftorient">

<p>
Förstärkningsorden <i>sehr, viel</i> och <i>viele</i> har en tendes att blandas ihop av många svenska tyskelever.
I de flesta fall gäller följande tumregel:
</p>

<table class="bggron">
    <i>
<tr>
<td><b>sehr</b></td>
<td>väldigt</td>
</tr>

<tr>
<td><b>viel</b></td>
<td>mycket</td>
</tr>

<tr>
<td><b>viele</b></td>
<td>många</td>
</tr>

</i>
</table>

<h4>sehr</h4>

<div class="quasi-p"><i>sehr (väldigt)</i> används framför <div class="inlajn bggron"> adjektiv eller adverb</div>. </div>

<br>
<div class="ruta">
<p>
    <i>Ich bin <b>sehr</b> böse. <br>Jag är <b>väldigt</b> ärg. </i></p>

<p>  <i> Das hier ist <b>sehr</b> viel.  <br>Det här är <b>väldigt</b> mycket.</i>


</p>
</div>

<br>

<h4>viel</h4>

<div class="quasi-p"> <i>viel (mycket)</i> används framför <div class="inlajn bggron"> oräknebara substantiv</div>. </div>
<br>

<div class="ruta">
<p> <i> Für Süßigkeiten braucht man  <b>viel</b> Zucker.  <br>För sötsaker behöver man  <b>mycket</b> socker.</i> </p>

<p>   <i>Ich habe nicht <b>viel</b> Zeit. <br>Jag har inte <b>mycket <div class="mindre inlajn">(mycken)</div></b> tid. </i></p>
</div>
<br>

<h4>viele</h4>

<div class="quasi-p"> <i>viele (många)</i> används framför <div class="inlajn bggron"> räknebara substantiv</div>. </div>
<br>
<div class="ruta">
<p>   <i>Zu dieser Schule gehen <b>viele</b> Schüler. <br>På denna skola går <b>många </b> elever. </i></p>

<p>   <i><b>Viele</b> Fragen haben keine Antworten. <br><b>Många </b> frågor har inga svar. </i></p>
</div>
<br><br><br>

<div class="mindre">
<h4>...es macht viel Spaß...</h4>
<p>Ett vanligt uttryck som lätt används fel på tyska och är värt att nämna i sammanhanget är <i>Spaß</i> som
    betyder <i>kul</i>. Problemet är att det svenska ordet <i>kul</i> är ett adjektiv och ofta föregås av ordet <i>väldigt</i>, medan det
    tyska <i>Spaß</i> är ett oräknebart substantiv och alltså måste föregås av <i>viel</i>.</p>

<div class="ruta">
    <p><i>Vi hade <b>väldigt kul</b>.<br>
    Wir hatten <b>viel Spaß</b>.</i></p>
</div>
<p>Dessutom säger vi på svenska att något <i>"<b>är</b> kul"</i>, medan det på tyska <i>"<b>macht</b> Spaß"</i>.</p>


<div class="ruta">
<p><i>Detta <b>är</b> kul.<br>
Dieses <b>macht</b> Spaß.</i></p>

<p><i>Det <b>är väldigt kul</b> att sjunga i kör.<br>
Es <b>macht viel Spaß</b>, in einem Chor zu singen.</i></p>

</div>

</div>
</div>
</div>

</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "sehr viel viele många mycket väldigt Spaß"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

th {
    font-weight: bold;
}
</style>
